import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServices";


const PendingOrders = () => {
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [sort, setSort] = useState(100); // Number of items per page
  const activePag = useRef(0);
  const [test, setTest] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeUsers, setActiveUsers] = useState([]);
  const [activePage, setActivePag] = useState();
  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState({})

  const [requisition, setRequisiton] = useState();
  const [selectedRequisition, setSelectedRequisiton] = useState();
  const [run, setRun] = useState(0);

  // Options for row selections
  const options = [
    { value: '5', label: '5' },
    { value: '10', label: '10' },
    { value: '20', label: '20' },
    { value: '50', label: '50' },
    { value: '100', label: '100' }
  ];



  useEffect(() => {
    if (selectedStore) {
      const status = "approved";
      RequestServies.getAllItem(undefined, status, selectedStore)
        .then((res) => {
          setData(res?.data?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [selectedStore, selectedRequisition, run]);

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
  };

  const handleRequsitionChange = (e) => {
    setSelectedRequisiton(e.target.value);
  };


  // Pagination setup
  useEffect(() => {
    if (data.length > 0) {
      setActivePag(0); // Reset pagination when data changes
    }
  }, [data]);

  const pagination = Math.ceil(data.length / sort);
  const onClick = (i) => {
    activePag.current = i;
    setTest(i);
  };

  const getReceiveStatus = (status) => {
    switch (status) {
      case "approved":
        return "PO Receiving Pending";
      case "local":
      case "local_receive_pending":
        return "Local Receiving Pending";
      default:
        return "-";
    }
  };

  return (
    <>


      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-6 col-xxl-6">
                      <label className="form-label ms-2">Select Store</label>
                      <select
                        className="form-select mb-xl-0 mb-3 pt-3 pb-3"
                        value={selectedStore}
                        onChange={handleStoreChange}
                      >
                        {stores.map((store) => (
                          <option key={store._id} value={store._id}>
                            {store.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-xl-6 col-xxl-6">
                      <label className="from-label ms-2">Select display Rows</label>
                      <Select
                        placeholder="Select row to display in User Table"
                        value={options.find(option => option.value === sort)} // set the current selected value
                        onChange={(selectedOption) => setSort(selectedOption.value)} // update `sort` on selection
                        isSearchable={false}
                        options={options}
                        className="custom-react-select mb-3 mb-xxl-0"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="filter cm-content-box box-primary mt-1">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fa fa-list me-2" aria-hidden="true"></i>Rejected Approvals{" "}
                <span className="badge bg-orange ms-2">{data.length}</span>
              </div>
              <div className="tools">
                <Link
                  to="#"
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <div style={{
                        overflowX: 'auto',
                        overflowY: 'auto',
                        maxHeight: '400px',
                        whiteSpace: 'nowrap',
                        position: 'relative',   // ✅ ADD THIS
                        zIndex: 0               // ✅ ADD THIS
                      }}>
                      <table
                        className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                        id="active-users-data"
                      >
                        <thead
                            style={{
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#fff",
                              zIndex: 1,              // ✅ LOWER than sidebar
                            }}
                          >
                          <tr>
                            <th>S.No</th>
                            <th>Requested Date</th>
                            <th>Requisition No</th>
                            <th>Part No</th>
                            <th>Description</th>
                            <th>RequestedQty</th>
                            <th>Request status</th>
                            <th>Pending Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.length > 0 ? (
                            data
                              .slice(
                                activePag.current * sort,
                                (activePag.current + 1) * sort
                              )
                              .map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    {activePag.current * sort + index + 1}
                                  </td>
                                  <td>{item?.createdAt.split("T")[0]}</td>
                                  <td>{item?.requisitionNo?.requisitionNo}</td>
                                  <td>{item?.inventory?.masterItem?.partNo}</td>
                                  <td className="scrollable-description">{item?.inventory?.masterItem?.description}</td>
                                  <td>{item?.qtyRequired}</td>
                                  <td className="text-danger fw-bold">{item?.flag}</td>
                                  <td className="text-center">
                                    {getReceiveStatus(item?.status)}
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="9" className="text-center">
                                No Active items Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      </div>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          Showing {activePag.current * sort + 1} to{" "}
                          {Math.min(
                            data.length,
                            (activePag.current + 1) * sort
                          )}{" "}
                          of {data.length} entries
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className="paginate_button previous"
                            to="#"
                            onClick={() =>
                              activePag.current > 0 &&
                              onClick(activePag.current - 1)
                            }
                          >
                            <i
                              className="fa fa-angle-double-left"
                              aria-hidden="true"
                            ></i>
                          </Link>
                          <span>
                            {Array.from({ length: pagination }, (_, i) => (
                              <Link
                                key={i}
                                to="#"
                                className={`paginate_button ${activePag.current === i ? "current" : ""
                                  }`}
                                onClick={() => onClick(i)}
                              >
                                {i + 1}
                              </Link>
                            ))}
                          </span>
                          <Link
                            className="paginate_button next"
                            to="#"
                            onClick={() =>
                              activePag.current < pagination - 1 &&
                              onClick(activePag.current + 1)
                            }
                          >
                            <i
                              className="fa fa-angle-double-right"
                              aria-hidden="true"
                            ></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingOrders;
